import { Component, ElementRef, signal, viewChild } from '@angular/core';
import { delay } from '@gametailors/web-core/misc';

@Component({
  selector: 'rid-overlay-feedback',
  imports: [],
  templateUrl: './rid-overlay-feedback.html',
  styleUrl: './rid-overlay-feedback.css',
  host: {
    class: 'contents',
  },
})
export class RidOverlayFeedback {
  protected color = signal<'red' | 'emerald'>('red');
  private rootEl = viewChild.required<ElementRef<HTMLDivElement>>('rootEl');
  private currentAnimation: AbortController | null = null;

  async showIncorrect() {
    await this.playAnimation('red', 'incorrect');
  }

  async showCorrect() {
    await this.playAnimation('emerald', 'correct');
  }

  private async playAnimation(color: 'red' | 'emerald', className: string) {
    // Cancel previous animation
    this.currentAnimation?.abort();

    const abortController = new AbortController();
    this.currentAnimation = abortController;

    const el = this.rootEl().nativeElement;
    this.color.set(color);

    // Remove all animation classes and force reflow
    el.classList.remove('incorrect', 'correct');
    void el.offsetWidth;

    // Add class to trigger animation
    el.classList.add(className);

    await delay(1500);

    // Only remove if this animation wasn't cancelled
    if (!abortController.signal.aborted) {
      el.classList.remove(className);
    }
  }
}
